import { IconsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/icon-wrapper';

export function SellerTraderOutlineIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <path
        d="M8.579 8.75c.168 1.833 1.72 3.25 3.607 3.25 1.888 0 3.398-1.375 3.608-3.25l.251-2.542c.126-1.083-.251-2.166-.964-2.958C14.367 2.458 13.319 2 12.186 2c-1.09 0-2.139.458-2.894 1.25-.713.792-1.09 1.875-.965 2.958L8.58 8.75zm1.971-4.375a2.197 2.197 0 011.636-.708c.63 0 1.217.25 1.636.708.42.458.63 1.042.545 1.667l-.251 2.541c-.084 1-.923 1.75-1.93 1.75a1.917 1.917 0 01-1.93-1.75l-.251-2.541c-.042-.584.126-1.209.545-1.667zm10.151 11.25l-.377-.208c-4.446-2.375-11.452-2.375-15.898 0l-.377.208L3 22h15.31l.504-1.667H4.97l.588-3.625c3.859-1.875 9.731-1.875 13.59 0l.336 2L20.03 22h1.72l-1.049-6.375z"
        fill="inherit"
        fillRule="evenodd"
      />
    </SvgWrapper>
  );
}
